/**
 * @deprecated Use functions from src/lib/api/index.ts instead
 * This file is kept for backward compatibility during migration
 */
import { put, post } from "./api/httpClient";
import { Availability } from "./api/types";

// Re-export auth functions from new API
export { login, register } from "./api/auth";

export async function updateUserAvailabilitySchedule(
  userId: string,
  index: number,
  schedule: Availability,
) {
  return put(`/availability/${userId}/${index}`, schedule, { cacheResponse: false });
}

export async function addUserAvailabilitySchedule(
  userId: string,
  index: number,
  schedule: Availability,
) {
  return post(`/availability/${userId}/${index}`, schedule, { cacheResponse: false });
}